// QuickLink.tsx
import React from "react";

interface Props {
  className?: string;
  fontSize?: any;
  color?: string;
  children: any;
}
export const QiuckLink: React.FC<Props> = ({ className, children }) => {
  return <span className={className}>{children}</span>;
};
